import { createContext } from 'react'

export const TabsContext = createContext({})
